document.addEventListener('DOMContentLoaded', function() {
    // Function to validate all required widgets
    function validateRequiredWidgets() {
        const allWidgets = document.querySelectorAll('.form-check-options-widget');
        const widgetsWithRequiredInputs = [];
        
        allWidgets.forEach(widget => {
            const requiredInputs = widget.querySelectorAll('.form-check-input[data-is-required="yes"]');
            if (requiredInputs.length > 0) {
                widgetsWithRequiredInputs.push(widget);
            }
        });
        
        let isValid = true;
        const failedWidgets = [];
        
        widgetsWithRequiredInputs.forEach(widget => {
            const requiredInputs = widget.querySelectorAll('.form-check-input[data-is-required="yes"]');
            
            let widgetValid = true;
            const unselectedRequired = [];
            
            requiredInputs.forEach(input => {
                if (!input.checked) {
                    widgetValid = false;
                    unselectedRequired.push(input);
                }
            });
            
            if (!widgetValid) {
                isValid = false;
                failedWidgets.push({ widget, unselectedRequired });
            }
        });
        
        return { isValid, failedWidgets };
    }
    
    // Function to show validation errors
    function showValidationErrors(failedWidgets) {
        failedWidgets.forEach(({ widget, unselectedRequired }) => {
            const items = widget.querySelectorAll('.form-check-item');
            items.forEach(item => item.classList.remove('error'));
            
            unselectedRequired.forEach(input => {
                const item = input.closest('.form-check-item');
                if (item) {
                    item.classList.add('error');
                }
            });
            
            const validationError = widget.querySelector('.form-check-validation-error');
            if (validationError) {
                validationError.classList.add('show');
                validationError.style.display = 'block';
            }
        });
        
        if (failedWidgets.length > 0) {
            const firstWidget = failedWidgets[0].widget;
            const validationError = firstWidget.querySelector('.form-check-validation-error');
            if (validationError) {
                validationError.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'center' 
                });
            }
        }
    }
    
    // Function to clear validation errors
    function clearValidationErrors() {
        const widgets = document.querySelectorAll('.form-check-options-widget');
        widgets.forEach(widget => {
            const items = widget.querySelectorAll('.form-check-item');
            items.forEach(item => item.classList.remove('error'));
            
            const validationError = widget.querySelector('.form-check-validation-error');
            if (validationError) {
                validationError.classList.remove('show');
                validationError.style.display = 'none';
            }
        });
    }
    
    // Intercept form submissions
    document.addEventListener('submit', function(e) {
        const allRequiredInputs = document.querySelectorAll('.form-check-input[data-is-required="yes"]');
        
        if (allRequiredInputs.length === 0) {
            return;
        }
        
        clearValidationErrors();
        
        const { isValid, failedWidgets } = validateRequiredWidgets();
        
        if (!isValid) {
            showValidationErrors(failedWidgets);
            e.preventDefault();
            e.stopPropagation();
            return;
        }
    }, true);
    
    // Clear errors when user makes changes and toggle active classes
    document.addEventListener('change', function(e) {
        if (e.target.classList.contains('form-check-input')) {
            const widget = e.target.closest('.form-check-options-widget');
            if (widget) {
                clearValidationErrors();
                
                const item = e.target.closest('.form-check-item');
                if (item) {
                    if (e.target.checked) {
                        item.classList.add('form-check-active');
                    } else {
                        item.classList.remove('form-check-active');
                    }
                }
                
                // Handle target selector functionality
                const targetSelector = e.target.getAttribute('data-target-selector');
                if (targetSelector && targetSelector.trim() !== '') {
                    const targetElement = document.querySelector(targetSelector);
                    if (targetElement && targetElement.type === 'checkbox') {
                        targetElement.checked = e.target.checked;
                        const changeEvent = new Event('change', { bubbles: true });
                        targetElement.dispatchEvent(changeEvent);
                    }
                }
            }
        }
    });
    
    // Update form input value when checkboxes change
    const checkboxes = document.querySelectorAll('.franchise-options input[type="checkbox"]');
    function updateFormInput() {
        const checkedOptions = document.querySelectorAll('.franchise-options input[type="checkbox"]:checked');
        const formInput = document.querySelector('.franchise-form input[name="option"]');
        if (formInput && checkedOptions.length > 0) {
            const selectedValues = Array.from(checkedOptions).map(checkbox => checkbox.value).join(', ');
            formInput.value = selectedValues;
        } else if (formInput) {
            formInput.value = '';
        }
    }
    checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updateFormInput);
    });
    updateFormInput();

    // Initialize active states for checked inputs
    const franchiseInputs = document.querySelectorAll('.franchise-options .form-check-input');
    franchiseInputs.forEach(function(input) {
        const item = input.closest('.form-check-item');
        if (item && input.checked) {
            item.classList.add('form-check-active');
        }
        
        // Handle target selector on initialization
        const targetSelector = input.getAttribute('data-target-selector');
        if (targetSelector && targetSelector.trim() !== '' && input.checked) {
            const targetElement = document.querySelector(targetSelector);
            if (targetElement && targetElement.type === 'checkbox') {
                targetElement.checked = input.checked;
                const changeEvent = new Event('change', { bubbles: true });
                targetElement.dispatchEvent(changeEvent);
            }
        }
    });

    function moveOptionsForMobile() {
        const options = document.querySelector('.franchise-options');
        const form = document.querySelector('.franchise-form');
        if (!options || !form) return;

        if (window.innerWidth < 1024) {
            if (form.previousElementSibling !== options) {
                form.parentNode.insertBefore(options, form);
            }
        } else {
            const rightCol = document.querySelector('.lg\\:grid-cols-\\[1fr_495px\\] .grid__item:last-child');
            if (rightCol && !rightCol.contains(options)) {
                rightCol.appendChild(options);
            }
        }
    }

    moveOptionsForMobile();
    window.addEventListener('resize', moveOptionsForMobile);
});
